import { defaultDashboardConfigs } from '../config/dashboardConfig';
import { markTimestamp } from './timestamp';

const now = markTimestamp();
const yesterday = markTimestamp(new Date(Date.now() - 24 * 60 * 60 * 1000));
const nextMonth = new Date();
nextMonth.setMonth(nextMonth.getMonth() + 1);

export const seedData = {
  users: {
    'admin@ybit.local': {
      name: 'System Administrator',
      username: 'admin',
      password: 'admin123',
      email: 'admin@ybit.local',
      role: 'administrator',
      designation: 'Administrator',
      department: 'Engineering Sciences & Humanities',
      phone: '9999999999',
      createdAt: now
    },
    'hod@ybit.local': {
      name: 'Dr. YBIT HOD',
      username: 'hod',
      password: 'hod123',
      email: 'hod@ybit.local',
      role: 'hod',
      designation: 'Head of Department',
      department: 'Engineering Sciences & Humanities',
      assignedDivision: 'A',
      phone: '9999999901',
      photoUrl: '/uploads/Hod.jpg',
      createdAt: now
    },
    'mentor@ybit.local': {
      name: 'Prof. Sample Mentor',
      username: 'mentor',
      password: 'mentor123',
      email: 'mentor@ybit.local',
      role: 'mentor',
      designation: 'Assistant Professor',
      department: 'Engineering Sciences & Humanities',
      assignedBatch: 'B1',
      phone: '9999999902',
      createdAt: now
    },
    'coordinator@ybit.local': {
      name: 'Prof. Class Coordinator',
      username: 'coordinator',
      password: 'coord123',
      email: 'coordinator@ybit.local',
      role: 'class_coordinator',
      designation: 'Class Coordinator',
      department: 'Engineering Sciences & Humanities',
      assignedDivision: 'A',
      phone: '9999999903',
      createdAt: now
    },
    'mc@ybit.local': {
      name: 'Prof. Mentoring Coordinator',
      username: 'mc',
      password: 'mc123',
      email: 'mc@ybit.local',
      role: 'mentoring_coordinator',
      designation: 'Mentoring Coordinator',
      department: 'Engineering Sciences & Humanities',
      phone: '9999999904',
      createdAt: now
    }
  },

  students: {
    FB101: {
      rollNumber: 'FB101',
      firstName: 'Aarav',
      surname: 'Patil',
      name: 'Aarav Patil',
      fatherName: 'Sanjay',
      motherName: 'Meena',
      dob: '15-08-2005',
      gender: 'Male',
      bloodGroup: 'B+',
      branch: 'Engineering Sciences',
      department: 'Engineering Sciences & Humanities',
      division: 'A',
      batch: 'B1',
      email: 'fb101@ybit.local',
      mobile: '9000000101',
      address: 'YBIT Campus Local Demo Address',
      photoUrl: '/uploads/FB101.jpg'
    },
    FB107: {
      rollNumber: 'FB107',
      firstName: 'Sai',
      surname: 'Sawant',
      name: 'Sai Sawant',
      fatherName: 'Mahesh',
      motherName: 'Rupali',
      dob: '22-09-2005',
      gender: 'Female',
      bloodGroup: 'O+',
      branch: 'Engineering Sciences',
      department: 'Engineering Sciences & Humanities',
      division: 'A',
      batch: 'B1',
      email: 'fb107@ybit.local',
      mobile: '9000000107',
      address: 'YBIT Campus Local Demo Address',
      photoUrl: '/uploads/FB107.jpg'
    },
    FB116: {
      rollNumber: 'FB116',
      firstName: 'Neel',
      surname: 'Kadam',
      name: 'Neel Kadam',
      fatherName: 'Ramesh',
      motherName: 'Pooja',
      dob: '03-01-2006',
      gender: 'Male',
      bloodGroup: 'A+',
      branch: 'Engineering Sciences',
      department: 'Engineering Sciences & Humanities',
      division: 'B',
      batch: 'B2',
      email: 'fb116@ybit.local',
      mobile: '9000000116',
      address: 'YBIT Campus Local Demo Address',
      photoUrl: ''
    }
  },

  secupin: {
    FB101: { rollNumber: 'FB101', pin: '123456', updatedAt: now },
    FB107: { rollNumber: 'FB107', pin: '123456', updatedAt: now },
    FB116: { rollNumber: 'FB116', pin: '123456', updatedAt: now }
  },

  attendance: {
    FB101: { rollNumber: 'FB101', totalLectures: 120, attendedLectures: 104, percentage: 87, overallPercentage: 86.67, theoryPercentage: 88.24, practicalPercentage: 84.62, month: 'May' },
    FB107: { rollNumber: 'FB107', totalLectures: 120, attendedLectures: 91, percentage: 76, overallPercentage: 75.83, theoryPercentage: 77.14, practicalPercentage: 73.33, month: 'May' },
    FB116: { rollNumber: 'FB116', totalLectures: 120, attendedLectures: 68, percentage: 57, overallPercentage: 56.67, theoryPercentage: 58.57, practicalPercentage: 53.33, month: 'May' }
  },

  iaTest1: {
    FB101: { rollNumber: 'FB101', studentName: 'Aarav Patil', division: 'A', total: 86, percentage: 81.9, subjects: { amI: 18, ap: 13, ac: 13, em: 17, bee: 16, pce: 9 } },
    FB107: { rollNumber: 'FB107', studentName: 'Sai Sawant', division: 'A', total: 78, percentage: 74.29, subjects: { amI: 16, ap: 12, ac: 12, em: 15, bee: 14, pce: 9 } },
    FB116: { rollNumber: 'FB116', studentName: 'Neel Kadam', division: 'B', total: 57, percentage: 54.29, subjects: { amI: 11, ap: 9, ac: 8, em: 12, bee: 11, pce: 6 } }
  },

  iaTest2: {
    FB101: { rollNumber: 'FB101', studentName: 'Aarav Patil', division: 'A', total: 92, percentage: 87.62, subjects: { amI: 19, ap: 14, ac: 14, em: 18, bee: 18, pce: 9 } },
    FB107: { rollNumber: 'FB107', studentName: 'Sai Sawant', division: 'A', total: 83, percentage: 79.05, subjects: { amI: 17, ap: 13, ac: 12, em: 16, bee: 16, pce: 9 } },
    FB116: { rollNumber: 'FB116', studentName: 'Neel Kadam', division: 'B', total: 62, percentage: 59.05, subjects: { amI: 12, ap: 10, ac: 9, em: 13, bee: 12, pce: 6 } }
  },

  batchAssignments: {
    B1: {
      batch: 'B1',
      mentorEmail: 'mentor@ybit.local',
      mentorName: 'Prof. Sample Mentor',
      studentCount: 2,
      updatedAt: now
    },
    B2: {
      batch: 'B2',
      mentorEmail: '',
      mentorName: '',
      studentCount: 1,
      updatedAt: now
    }
  },

  divisionAssignments: {
    A: {
      division: 'A',
      coordinatorEmail: 'coordinator@ybit.local',
      coordinatorName: 'Prof. Class Coordinator',
      ccName: 'Prof. Class Coordinator',
      studentCount: 2,
      updatedAt: now
    },
    B: {
      division: 'B',
      coordinatorEmail: '',
      coordinatorName: '',
      ccName: '',
      studentCount: 1,
      updatedAt: now
    }
  },

  achievements: {
    ach_sample_1: {
      rollNumber: 'FB101',
      studentName: 'Aarav Patil',
      title: 'Technical Quiz Winner',
      category: 'academic',
      description: 'Won first prize in the department technical quiz.',
      status: 'verified',
      batch: 'B1',
      submittedAt: yesterday,
      verificationDate: now
    },
    ach_sample_2: {
      rollNumber: 'FB107',
      studentName: 'Sai Sawant',
      title: 'Poster Presentation',
      category: 'academic',
      description: 'Submitted poster presentation certificate for approval.',
      status: 'pending',
      batch: 'B1',
      submittedAt: now
    }
  },

  leaves: {
    leave_sample_1: {
      rollNumber: 'FB116',
      studentName: 'Neel Kadam',
      reason: 'Medical leave',
      fromDate: new Date().toISOString().slice(0, 10),
      toDate: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
      status: 'pending',
      submittedAt: now
    }
  },

  announcements: {
    ann_sample_1: {
      title: 'Offline Demo Notice',
      message: 'This local copy is running without Firebase or internet. Data changes are saved in this browser.',
      audience: 'all',
      priority: 'normal',
      createdBy: 'System Administrator',
      createdAt: now,
      expiryDate: nextMonth.toISOString(),
      readBy: []
    }
  },

  notifications: {
    'FB101/messages': {
      note_sample_1: {
        title: 'Welcome',
        message: 'Welcome to the offline YBIT mentoring system.',
        type: 'info',
        isRead: false,
        createdAt: now
      }
    }
  },

  sentMessages: {},
  messages: {},
  customWidgets: {},
  careerAptitudeTests: {},
  dashboardConfigs: defaultDashboardConfigs
};
